/**
 * Helper module to format weblog events (ex: PDP events, breadcrumb)
 * Topic "weblog_events"
 */

export default { 
    
    getEvents(clear) {
        // this will hold final event list
        let events = [];
        //console.log('window.przEvQ', window.przEvQ);
        if(!Array.isArray(window.przEvQ)){
            // no events
            return events;
        }
        
        // parse list
        window.przEvQ.forEach( element => {
            if(!element.hasOwnProperty('t') || !element.hasOwnProperty('a')){
                // element must have "t" (time) and "a" (action) property
                return;
            }
            
            events.push(element);
            
//            // get list of arguments (first in list is "action")
//            let args = [];
//            for(let i = 1; i < element.args.length; i++){
//                args.push(element.args[i]);
//            }
//            // add to final list
//            events.push({
//                // time
//                time: element.time,
//                // action
//                act: element.args[0],
//                // data
//                args: args
//            });
        });
        
        if(clear === true){
            //console.log('PDP events: clear queue');
            window.przEvQ = [];
        }
        
        //console.log('PDP events:', events);
        return events;
    },
    
//    getStartTime(){
//        return window.przEvTime || null;
//    },

    addEvent(context, action, data, save = false) {
        // event queue
        window.przEvQ = window.przEvQ || [];
		
		let time = typeof performance !== 'undefined' ? performance.now() : null;
		if(!time){
			if(typeof window.przEvTime === 'undefined'){
				window.przEvTime = Date.now();
				time = 0;
			}
			else{
				time = Date.now() - window.przEvTime;
			}
		}
		window.przEvQ.push({t: time, c: context, a: action, d: data});
		if(window.mub){
			window.mub.logger.log('przEvQ Added event', {t: time, c: context, a: action, d: data});			
		}
		//console.log('przEvQ Added event', {t: time, c: context, a: action, d: data});
        // time 
//        if(typeof window.przEvTime === 'undefined'){
//            let start = 0;
//            if(typeof performance !== 'undefined'){
//                const nav = performance.getEntriesByType("navigation")[0];
//                start = nav ? Math.round(nav.loadEventEnd) : start;
//            }
//            window.przEvTime = new Date() - start;
//            console.log('window.przEvTime', window.przEvTime, start);
//        }
//        window.przEvQ.push({t: (new Date() - window.przEvTime), c: context, a: action, d: data});
//        console.log('przEvQ Added event', {t: (new Date() - window.przEvTime), c: context, a: action, d: data});
        if(save && window.mub){
			window.mub.logger.log('przEvQ forcing save data', window.przEvQ);			
            window.mub.flushData('przEvQ_add');
        }
    },   

    /**
     * Check if OT exists in URL and triggers event "ot". This is here in JS as 
     * an exception, because we can add validations not possible in server side (PHP)
     * 
     * @void
     */
    checkOtAccess(){
        const urlParams = new URLSearchParams(window.location.search);
        const ot = urlParams.get('ot');
        if(!ot || !ot.length){
            // nothing to do
            return;
        }
        if(document.referrer.length && this.referrerSameOrigin()){
            // referrer is from same origin, skip it
            return;
        }
        // currently, validation navigation type is disabled
//        const navType = String(window.performance.getEntriesByType('navigation')[0].type);
//        if(navType === 'reload' || navType === 'back_forward'){
//            // back/forward or refresh, ignore it
//            return;
//        }
        
        // check referrer from same domain
        this.addEvent('access', 'ot', {ot: ot});
    },
    
    referrerSameOrigin() {
        try {
            const referrer = new URL(document.referrer);
            return (referrer.origin === document.location.origin);
        } catch(err) {
            return false;
        }
    }    
};
